<template>
  <div>
    <h1 class="mb-0">Reset Password</h1>
    <p>{{ this.changeChoice }}</p>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
  
     <Error_messages :error_message="messages.error" :success_message = "messages.success"/>
    <form class="mt-4" novalidate @submit.prevent="handleSubmit(onSubmit)">
      <ValidationProvider  :name="inputType" rules="required" v-slot="{ passed, failed, failedRules, errors }">
        <b-form-group v-if="inputType === 'phone'" label="Phone Number">
          <div class="form-group">
            <phone-number
                    v-model="user.phone"
                    :rules="rules.phone"
                    :errors.sync="phone_value_change" 
                  />
                  <p v-if="phone_value_change" class="text-danger">{{ phone_value_change }}</p>
        
          </div>    
        </b-form-group>
        <b-form-group v-else label="Email" label-for="email" >
            <b-form-input id="email" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"     type="email" placeholder="Enter your email..." v-model="user.email"></b-form-input>
            <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.email ? validation_messages.email[Object.keys(failedRules)[0]] : errors[0] }} </div>
        </b-form-group>
      </ValidationProvider>
          <p @click="toggleInputType" style="cursor:pointer; width: fit-content;" class=" text-primary font-size-16 font-weight-bold mb-3">
            you have {{ inputType === 'phone' ? 'an email ?' : 'a phone number ?' }}
          </p>

      <div class="d-inline-block w-100">
        <b-spinner v-if="loading" variant="primary" class="float-right" label="Spinning"></b-spinner>
        <button v-else type="submit" class="btn btn-primary float-right">Reset Password</button>
      </div>
    </form>
  </ValidationObserver>
   </div>
</template>
<script>
import { forgotpassword } from '../../../API/UsersAPIs';
import PhoneNumber from '@/components/PhoneNumber.vue';
import Error_messages from "@/helpers/error_messages.vue";
import { core } from '@/config/pluginInit';
export default {
  name: 'RecoverPassword1',
  components: 
  { 
    PhoneNumber,Error_messages
  },
  data(){
    return{
      phone_value_change: '',
      loading:false,
      changeChoice: 'Enter your phone number or email to reset your password.',
      messages: { error: "", success: "" },
      isPhoneValid: false,
      inputType: 'email',
      forgotpasswordStep1: { email: '', message: '', phone: ''},
      user: {phone: '', email: ''},
      rules: {email: 'required|email', phone: 'required'},
      validation_messages: {
        email: {
          required: 'Email is required',
        },
      },
      
    }
  },
  mounted() {
  core.index();
},
  methods:{
    // changeChoice between email and phone
    toggleInputType() {
      this.inputType = this.inputType === 'phone' ? 'email' : 'phone';
      this.changeChoice = this.inputType === 'phone' ? 'Enter your phone number to reset your password.' : 'Enter your email address to reset your password.';
      //  check if user choose phone input then set email to null and vice versa
      this.inputType === 'phone' ? this.user.email = null : this.user.phone = null;
    },
    async onSubmit(){
      if (this.inputType === 'phone') {
        if (this.phone_value_change) return; 
        this.user = { phone: this.user.phone.formattedNumber };
      } else if (this.inputType === 'email') {
        this.user = { email: this.user.email }; 
      }
      this.loading = true;
      this.messages.error = '';
      // call the forgotpassword API to send the code to the user's phone number or email address
      try {
       const data = await forgotpassword(this.user);
        this.$store.commit('User/setForgotpasswordStep1', {
          phone: this.user.phone,
          email: this.user.email,
          message: data.message,
      });
      this.loading = false;
        this.messages.error="";
        this.$router.push('/auth/confirm-mail1');
      } catch (error) {

        if(error.message === "Network Error"){
          this.messages.error = error.message;
        }else{
          if(this.inputType === 'email'){
            this.messages.error = error.response.data.errors.email[0];
          }else if(this.inputType === 'phone'){
            this.messages.error = error.response.data.errors.phone[0];
          }
        }
          
        
    }finally{ this.loading = false }
      
    },
  }
}
</script>
